import { FC, PropsWithChildren, ReactNode } from 'react';

import {
  HiddenRadioButton,
  StyledRadioButton,
  StyledRadioButtonLabel,
} from './styles';

interface RadioButtonProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>,
    PropsWithChildren {
  label?: ReactNode;
  testID: string;
}

export const RadioButton: FC<RadioButtonProps> = ({
  children,
  label,
  testID,
  ...rest
}) => {
  return (
    <>
      <StyledRadioButtonLabel>
        <HiddenRadioButton type="radio" {...rest} />
        <StyledRadioButton data-testid={testID} />
        {label}
      </StyledRadioButtonLabel>
      {children}
    </>
  );
};
